import { useQueryClient } from '@tanstack/react-query';
import { isBalanceRejection } from '../services/invoiceRejection';
import { agreementKeys } from './agreementKeys';
import type { InvoiceRejectionReason } from '../types/agreements.types';

export function useBalanceRejectionRefresh() {
    const queryClient = useQueryClient();

    return (agreementId: string | undefined, reasons: InvoiceRejectionReason[]): Promise<void> | undefined => {
        if (agreementId && isBalanceRejection(reasons)) {
            return queryClient.invalidateQueries({ queryKey: agreementKeys.cashPosition(agreementId) });
        }
    };
}
